<template>
  <div class="ed-checkbox">
    <input type="checkbox" :name="name" :id="id" :disabled="disabled" :checked="isChecked" :value="value" tabindex="-1" class="ed-checkbox__input" @click.stop="toggleCheck">

    <label :for="id" class="ed-checkbox__label">
      <span class="ed-checkbox__label-text" v-if="$slots.default"><slot></slot></span>
    </label>
  </div>
</template>

<script>

  export default {
    name: 'Checkbox',
    props: {
      name: String,
      value: [String, Boolean],
      id: String,
      disabled: Boolean,
      checked: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        currentCheck: this.checked,
      };
    },
    computed: {
      isChecked() {
        if (this.currentCheck === true) {
          return true;
        }
        return false;
      },
    },
    methods: {
      toggleCheck($event) {
        if (!this.disabled) {
          this.currentCheck = !this.currentCheck;
          if (this.currentCheck) {
            this.$emit('check', this.value, $event);
          } else {
            this.$emit('uncheck', this.value, $event);
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// checkbox.vue?0719a07e